// extracted by mini-css-extract-plugin
export default {"container":"GaDY9_","subtotal":"vekPIF"};